import { render, staticRenderFns } from "./cartTrapezSSR.vue?vue&type=template&id=1dc0ad8a&"
import script from "./cartTrapezSSR.vue?vue&type=script&lang=js&"
export * from "./cartTrapezSSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports